import { Link } from "react-router-dom";
import arrowLeftGray from "../../assets/images/svg/arrow-left-gray.svg";
import arrowRightGray from "../../assets/images/svg/arrow-right-gray.svg";
 
export default function BlogPagination() {
	return (
		<div className="fugu-pagination">
			<nav aria-label="Page navigation example">
				<ul className="pagination">
					<li className="page-item">
						<Link to={"/"}  className="page-link" aria-label="Previous" >
								<span aria-hidden="true">
									<img src={arrowLeftGray} alt="" />
								</span>
							
						</Link>
					</li>
					<li className="page-item">
						<Link to={"/"}  className="page-link active" >
						1
						</Link>
					</li>
					<li className="page-item">
						<Link to={"/"}  className="page-link" >
						2
						</Link>
					</li>
					<li className="page-item">
						<Link to={"/"}  className="page-link" >
						3
						</Link>
					</li>
					<li className="page-item">
						<Link to={"/"}  className="page-link" aria-label="Next" >
								<span aria-hidden="true">
									<img src={arrowRightGray} alt="" />
								</span>
						
						</Link>
					</li>
				</ul>
			</nav>
		</div>
	);
}
